import { Box } from "@mui/material";
import { useEffect } from "react";
import { useGlobalAuthContext } from "../context/AuthContext";
import { useGetPackagesQuery } from "../Slices/roomNateApis";
import PackagesTable from "../Components/packages/PackagesTable";

const Packages = () => {
  const { currentUserSessionStorage } = useGlobalAuthContext();

  const { data: FetchPackages, isLoading, error } = useGetPackagesQuery(
    {},
    {
      skip: !currentUserSessionStorage,
    }
  );

  // DEBUG: Log API response to diagnose data issues (dev only)
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      console.log('[Packages Page] 🔍 DEBUG - FetchPackages:', FetchPackages);
      console.log('[Packages Page] 🔍 DEBUG - FetchPackages type:', typeof FetchPackages);
      console.log('[Packages Page] 🔍 DEBUG - FetchPackages isArray:', Array.isArray(FetchPackages));
      console.log('[Packages Page] 🔍 DEBUG - FetchPackages length:', FetchPackages?.length);
      console.log('[Packages Page] 🔍 DEBUG - isLoading:', isLoading);
      console.log('[Packages Page] 🔍 DEBUG - error:', error);
    }
  }, [FetchPackages, isLoading, error]);

  return (
    <Box>
      <PackagesTable
        productsData={FetchPackages}
      />
    </Box>
  );
};

export default Packages;
